<ion-item-sliding lines="none" class="ion-no-margin">
	<ion-item lines="none" class="ion-no-margin ion-no-padding" (click)="selectCard()" data-cy="selectCard">
		<ion-label>{{ cardText }}</ion-label>
	</ion-item>

	<ion-item-options side="end" class="ion-no-border">
		<ion-item-option class="ion-no-border edit" (click)="handleEditConnection($event)">
			<ion-icon
				appThrottleButtonDirective
				[throttleTime]="2000"
				data-cy="editConnection"
				class="ion-no-padding icon-Edit"
			></ion-icon>
			<ion-label class="edit">Edit</ion-label>
		</ion-item-option>
		<ion-item-option
			class="ion-no-border delete"
			[ngClass]="{ disabled: isDeleteDisabled }"
			(click)="handleDeleteConnection($event)"
		>
			<ion-icon
				appThrottleButtonDirective
				[throttleTime]="2000"
				data-cy="deleteConnection"
				class="ion-no-padding icon-Delete"
			></ion-icon>
			<ion-label class="delete">Delete</ion-label>
		</ion-item-option>
	</ion-item-options>
</ion-item-sliding>
